export const USERS = "/users";
export const LISTINGS = "/listings";
export const LISTING = "/listings";
export const TOP_DESTINATIONS = "/top-locations";
export const FEATURES = "/features";
export const REVIEWS = "/reviews";
export const SETTINGS = "/settings";
export const CHECKOUT_SESSION = "/checkout-session";
